import React from 'react';
import { Bar, Chart } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Utils from '../../../providers/Utils';


export default class BilantChartData extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
        Chart.plugins.unregister(ChartDataLabels);
    }
    render() {
        return (
     

                <div style={{
                    width: '45%', display: 'inline-block',
                    position: 'relative',
                    border: '1px dashed gray',
                    padding: 10,
                    marginRight: 20, marginTop: 30, verticalAlign: 'top'
                }}
                
                >
                    <h4 style={{ marginBottom: 0 }} className='pm-title'>{this.props.ch.titlu}</h4>
                    <Bar

                        datasetKeyProvider={() => { return Math.random() }}
                        // getElementAtEvent={(element)=>this.getLineData(element,i)}
                        plugins={[ChartDataLabels]}

                        data={{
                            labels: this.props.ch.labels.map((r) => { return (r) }),
                            datasets: [
                                {
                                    //    label:ch.chartData.map((r)=>{return(Number(r))}) ,
                                    backgroundColor: this.props.ch.culori.map((r) => { return (r) }),
                                    hoverBackgroundColor: this.props.ch.chartData.map((r) => { return (new Utils().culoriCharts(Number(r))) }),
                                    data: this.props.ch.chartData.map((r) => { return (Number(r).toFixed(2)) }),

                                },

                            ],


                        }}

                        options={{

                            onClick: function (evt, elements) {

                                let selectedIndex = null
                                if (elements && elements.length) {
                                    var segment = elements[0];
                                    this.update();
                                    if (selectedIndex !== segment["_index"]) {
                                        selectedIndex = segment["_index"];
                                        segment._model.outerRadius += 20;
                                    }
                                    else {
                                        selectedIndex = null;
                                    }
                                }
                            },
                            layout: {
                                padding: 60,
                                height: 300
                            },

                            plugins: {

                                datalabels: {
                                    color: 'black',
                                    formatter: (value, context) => {
                                        // console.log('value :', value);
                                        //    console.log('context :', );

                                        return value

                                    },
                                    font: {
                                        size: 16,
                                        weight: 600
                                    },
                                    align: 'end',
                                    display: 'auto',
                                    clamp: true


                                },

                            },
                            legend: {
                                display: false
                            }
                        }}

                    />
                    {/* <h5 className='pm-title'>{ch.help}</h5> */}
                    <h6 className='pm-title'>{this.props.ch.help}</h6>
                </div>




         
        );
    }
}